// src/App.js
import React, { useEffect, useState } from "react";
import './App.css';
import WeatherNowDisplay from './components/organism/WeatherNowDisplay';
import WeatherDetailDisplay from './components/organism/WeatherDetailDisplay';
import WeatherForecastDisplay from './components/organism/WeatherForecastDisplay';
import BackgroundImage from './components/atom/BackgroundImages';
import Clock from './components/atom/Clock';
import Panel from "./components/atom/Panel";

import { fetchWeatherData, fetchForecastData } from "./services/weatherService";
import { mapWeatherApiResponse, mapForecastApiResponse } from "./utils/mapWeatherdata";


function App() {
  const [city, setCity] = useState("auto:ip");
  const [weatherData, setWeatherData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const backgroundImage = BackgroundImage({
    name: weatherData?.weatherNow?.conditionMapped || 'clouds'
  });

  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 599;

  useEffect(() => {
    async function getWeather() {
      setIsLoading(true);
      setError(null);

      try {
        const current = await fetchWeatherData(city);
        const forecast = await fetchForecastData(city, 3);

        // ⛔ Wenn API einen Fehlercode zurückgibt, werfen wir einen passenden Fehler
        if (current?.error?.code === 1006 || forecast?.error?.code === 1006) {
          throw new Error("Location not found. Please try another search.");
        }

        const mappedCurrent = mapWeatherApiResponse(current);
        const mappedForecast = mapForecastApiResponse(forecast);

        setWeatherData({
          ...mappedCurrent,
          forecastToday: mappedForecast
        });

      } catch (err) {
        console.error("❌ Fehler beim Abrufen:", err);
        setError(err.message || "Etwas ist schiefgelaufen.");
      } finally {
        setIsLoading(false);
      }
    }

    getWeather();
  }, [city]);

  const handleSearch = (newCity) => {
    setCity(newCity);
  };

  // ⏳ Ladezustand
  if (isLoading) {
    return (
      <div className="loading-container">
        <Panel className="loading-panel">
          <p>Seite lädt...</p>
        </Panel>
      </div>
    );
  }

  // ✅ Normale Anzeige
  return (
    <div
      className="app-background"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <div className="app-container">
        {/* 📱 Nur bei kleinen Bildschirmen wird Stadt & Uhr oben angezeigt */}
        {isMobile && weatherData && (
  <div className="mobile-top-section">
    <div className="mobile-clock">
      <h2 className="mobile-city-name">{weatherData.city}</h2>
      <Clock timeString={weatherData.localtimeFull} />
    </div>
  </div>
)}

      <div className="grid-wrapper">
        <div className="weather-now">
        <WeatherNowDisplay data={weatherData} onSearch={handleSearch} error={error} />
        </div>

        <div className="weather-details-forecast">
          <WeatherDetailDisplay data={weatherData} />
          <WeatherForecastDisplay data={weatherData} />
        </div>
      </div>
      </div>
    </div>
  );
}

export default App;
